import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  WebDomEcommerceLogo,
  WebDomFintechLogo,
  WebDomHealthcareLogo,
  WebDomEducationLogo,
  WebDomSocialLogo,
  WebDomHospitalityLogo,
  WebDomEntertainmentLogo,
  WebDomGovernmentLogo,
  WebDomRealEstateLogo,
  WebDomBusinessLogo,
  WebDomOnDemandLogo,
  WebDomTechITLogo,
  WebDomNonProfitLogo,
  WebDomAutomativeLogo,
  WebDomTourLogo,
} from "../../../app-constants";

function Domaindiversity() {
  return (
    <section
      className="domain_diversity p-100"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              Industries We Serve As a Versatile{" "}
              <span>Blockchain Development Company</span>
            </h2>
            <p>
              Learn about the Ethereum application development services offered
              to launch innovative blockchain solutions. From a highly focused
              and advanced platform like Ethereum to a relatively new technology
              like Polkadot, our expert blockchain developers are masters at
              working on the appropriate platform in line with your business
              needs.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="domain_main">
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomEcommerceLogo}
                  <h6>eCommerce</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomFintechLogo}
                  <h6>Fintech</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomHealthcareLogo}
                  <h6>Healthcare</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomEducationLogo}
                  <h6>Education</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomSocialLogo}
                  <h6>Social Networking</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomHospitalityLogo}
                  <h6>Hospitality</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomEntertainmentLogo}
                  <h6>Entertainment</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomGovernmentLogo}
                  <h6>Government</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomRealEstateLogo}
                  <h6>Real Estate</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomBusinessLogo}
                  <h6>Business</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomOnDemandLogo}
                  <h6>Logistics</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomTechITLogo}
                  <h6>Tech & IT</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomNonProfitLogo}
                  <h6>Non-Profit</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomAutomativeLogo}
                  <h6>Automotive</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomTourLogo}
                  <h6>Travel & Tourism</h6>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Domaindiversity;
